import { SEO } from '../../utils/seo';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import Hero from './components/Hero';
import BusinessMap from './components/BusinessMap';
import ResearchAutomation from './components/ResearchAutomation';
import ProfitCalculation from './components/ProfitCalculation';
import ListingAutomation from './components/ListingAutomation';
import PriceAutomation from './components/PriceAutomation';
import InventoryAutomation from './components/InventoryAutomation';
import ShippingAutomation from './components/ShippingAutomation';
import AdvertisingAutomation from './components/AdvertisingAutomation';
import ReportAutomation from './components/ReportAutomation';
import TechStack from './components/TechStack';
import AutomationLevels from './components/AutomationLevels';
import BusinessPerspective from './components/BusinessPerspective';
import Conclusion from './components/Conclusion';

export default function AmazonAutomation() {
  const schema = {
    '@type': 'Article',
    headline: 'Amazon自動化の完全ガイド｜8つの業務を自動化する方法',
    description: 'Amazon販売における商品リサーチ、利益計算、出品、価格調整、在庫管理、発送、広告運用、利益分析の8つの業務を自動化する具体的な方法を解説。',
    author: {
      '@type': 'Organization',
      name: 'ECオートパイロットOS'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ECオートパイロットOS'
    },
    datePublished: '2025-01-15',
    dateModified: '2025-01-15',
    mainEntityOfPage: {
      '@type': 'WebPage'
    },
    articleSection: 'EC自動化',
    keywords: 'Amazon自動化,EC自動化,価格改定,在庫管理,広告運用,利益計算'
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Amazon自動化の完全ガイド｜8つの業務を自動化｜ECオートパイロットOS"
        description="Amazon販売における商品リサーチ、利益計算、出品、価格調整、在庫管理、発送、広告運用、利益分析の8つの業務を自動化する具体的な方法を解説。月商100万から1000万超まで対応するレベル別自動化戦略。"
        keywords="Amazon自動化,EC自動化,価格改定,在庫管理,広告運用,利益計算,Amazon販売,FBA"
        path="/amazon-automation"
        schema={schema}
      />
      <Header />
      <main>
        <Hero />
        <BusinessMap />
        <ResearchAutomation />
        <ProfitCalculation />
        <ListingAutomation />
        <PriceAutomation />
        <InventoryAutomation />
        <ShippingAutomation />
        <AdvertisingAutomation />
        <ReportAutomation />
        <TechStack />
        <AutomationLevels />
        <BusinessPerspective />
        <Conclusion />
      </main>
      <Footer />
    </div>
  );
}
